import moment from 'moment-timezone'
import {config} from '../config'
import store from '../store'

const getUserTimeZone = function() {
  return moment.tz.guess()
}

const formatTime = function(millisStamp, timeZone, zoned) {
  if (millisStamp === null) {
    return null
  } else {
    return moment(millisStamp)
      .tz(timeZone)
      .format(zoned ? config.dateTimeFormatZoned : config.dateTimeFormat)
  }
}

const formatTimeUserZone = function(millisStamp, zoned) {
  return formatTime(millisStamp, getUserTimeZone(), zoned)
}

const formatTimeByComparisonSource = function(
  millisStamp,
  gateway,
  surce,
  zoned,
) {
  const timeZone = store.state.user.gatewayLookup[gateway].timeZone
  return formatTime(millisStamp, timeZone, zoned)
}

export {
  formatTimeUserZone,
  getUserTimeZone,
  formatTime,
  formatTimeByComparisonSource,
}
